import { call, put, take, takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { api } from 'services';
import { notificationContainer } from 'utils/notificationContainer';
import {
	getConfirmedOrdersRequest,
	getConfirmedOrdersSuccess,
	getConfirmedOrdersForFilterIdRequest,
	getConfirmedOrdersForFilterIdSuccess,
	getOrderDetailsRequest,
	getOrderDetailsSuccess,
	getOrderDetailsCombinedRequest,
	getOrderDetailsCombinedSuccess,
	getOrderDiscountsRequest,
	getOrderDiscountsSuccess,
	getReturnedOrdersRequest,
	getReturnedOrdersSuccess,
	getOrderReturnBreakdownRequest,
	getOrderReturnBreakdownSuccess,
	getOrderDiscountBreakdownRequest,
	getOrderDiscountBreakdownSuccess,
	getOrderVatCorrectionsBreakdownRequest,
	getOrderVatCorrectionsBreakdownSuccess,
	getOrderReturnItemsRequest,
	getOrderReturnItemsSuccess,
	createOrderReturnRequest,
	createOrderReturnSuccess,
	getOrderDiscountItemsRequest,
	getOrderDiscountItemsSuccess,
	createOrderDiscountRequest,
	createOrderDiscountSuccess,
	getVatAndEASFeeRequest,
	getVatAndEASFeeSuccess,
} from './reducer';
import {
	TConfirmedOrdersResponsePayload,
	TOrderDetailsRequest,
	TOrderDetailsResponsePayload,
	TOrderDiscountsRequest,
	TOrderDiscountsResponsePayload,
	TOrdersRequest,
	TReturnedOrdersRequest,
	TReturnedOrdersResponsePayload,
	TOrderReturnBreakdownResponsePayload,
	TOrderReturnBreakdownRequest,
	TOrderDiscountBreakdownRequest,
	TOrderDiscountBreakdownResponsePayload,
	TOrderVatCorrectionsBreakdownRequest,
	TOrderVatCorrectionsBreakdownResponsePayload,
	TOrderReturnItemsRequest,
	TOrderReturnItemsResponsePayload,
	TCreateOrderReturnActionPayload,
	TOrderDiscountItemsRequest,
	TOrderDiscountItemsResponsePayload,
	TCreateOrderDiscountActionPayload,
	TVatAndEASFeeResponsePayload,
	TOrderDetailsCombinedRequest,
	TOrderDetailsCombinedResponsePayload,
} from './types';
import { refreshTokenByTimeOutRequest, refreshTokenByTimeOutSuccess } from '../auth/reducer';

function* getConfirmedOrdersWorker(action: PayloadAction<TOrdersRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TConfirmedOrdersResponsePayload = yield call(
			api.orders.getConfirmedOrders,
			payload,
		);
		yield put(getConfirmedOrdersSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getConfirmedOrdersForFilterIdWorker(action: PayloadAction<TOrdersRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TConfirmedOrdersResponsePayload = yield call(
			api.orders.getConfirmedOrders,
			payload,
		);
		yield put(getConfirmedOrdersForFilterIdSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getReturnedOrdersRequestWorker(action: PayloadAction<TReturnedOrdersRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TReturnedOrdersResponsePayload = yield call(
			api.orders.getReturnedOrders,
			payload,
		);
		yield put(getReturnedOrdersSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getOrderDiscountsRequestWorker(action: PayloadAction<TOrderDiscountsRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TOrderDiscountsResponsePayload = yield call(
			api.orders.getOrderDiscounts,
			payload,
		);
		yield put(getOrderDiscountsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getOrderDetailsRequestWorker(action: PayloadAction<TOrderDetailsRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TOrderDetailsResponsePayload = yield call(api.orders.getOrderDetails, payload);
		yield put(getOrderDetailsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getOrderDetailsCombinedRequestWorker(
	action: PayloadAction<TOrderDetailsCombinedRequest>,
) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TOrderDetailsCombinedResponsePayload = yield call(
			api.orders.getOrderDetailsCombined,
			payload,
		);
		yield put(getOrderDetailsCombinedSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
	}
}

function* getOrderReturnBreakdownRequestWorker(
	action: PayloadAction<TOrderReturnBreakdownRequest>,
) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TOrderReturnBreakdownResponsePayload = yield call(
			api.orders.getOrderReturnBreakdown,
			payload,
		);
		yield put(getOrderReturnBreakdownSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getOrderDiscountBreakdownRequestWorker(
	action: PayloadAction<TOrderDiscountBreakdownRequest>,
) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TOrderDiscountBreakdownResponsePayload = yield call(
			api.orders.getOrderDiscountBreakdown,
			payload,
		);
		yield put(getOrderDiscountBreakdownSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getOrderVatCorrectionsBreakdownRequestWorker(
	action: PayloadAction<TOrderVatCorrectionsBreakdownRequest>,
) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TOrderVatCorrectionsBreakdownResponsePayload = yield call(
			api.orders.getOrderVatCorrectionsBreakdown,
			payload,
		);
		yield put(getOrderVatCorrectionsBreakdownSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getOrderReturnItemsRequestWorker(action: PayloadAction<TOrderReturnItemsRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TOrderReturnItemsResponsePayload = yield call(
			api.orders.getOrderReturnItems,
			payload,
		);
		yield put(getOrderReturnItemsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* createOrderReturnRequestWorker(action: PayloadAction<TCreateOrderReturnActionPayload>) {
	const { orderId, ...returnPayload } = action.payload;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		yield call(api.orders.createOrderReturn, returnPayload);
		const orderDetails: TOrderDetailsCombinedResponsePayload = yield call(
			api.orders.getOrderDetailsCombined,
			{ orderId },
		);
		yield put(getOrderDetailsCombinedSuccess(orderDetails));
		yield put(createOrderReturnSuccess());
		notificationContainer('Order return created successfully', 'success');
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(error?.response?.data.message ?? error?.message ?? 'Error', 'error');
			yield put(createOrderReturnSuccess());
		}
	}
}

function* getOrderDiscountItemsRequestWorker(action: PayloadAction<TOrderDiscountItemsRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TOrderDiscountItemsResponsePayload = yield call(
			api.orders.getOrderDiscountItems,
			payload,
		);
		yield put(getOrderDiscountItemsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* createOrderDiscountRequestWorker(
	action: PayloadAction<TCreateOrderDiscountActionPayload>,
) {
	const { orderId, ...discountPayload } = action.payload;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		yield call(api.orders.createOrderDiscount, discountPayload);
		const orderDetails: TOrderDetailsCombinedResponsePayload = yield call(
			api.orders.getOrderDetailsCombined,
			{ orderId },
		);
		yield put(getOrderDetailsCombinedSuccess(orderDetails));
		yield put(createOrderDiscountSuccess());
		notificationContainer('Order discount created successfully', 'success');
	} catch (error) {
		// console.log('error', (error as any)?.response?.data.message);
		if (axios.isAxiosError(error)) {
			notificationContainer(error?.response?.data.message ?? error?.message ?? 'Error', 'error');
			yield put(createOrderDiscountSuccess());
		}
		// yield put(assetsInitState());
	}
}

function* getVatAndEASFeeRequestWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TVatAndEASFeeResponsePayload = yield call(api.orders.getVatAndEASFee);
		yield put(getVatAndEASFeeSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
	}
}

export function* ordersSaga() {
	yield takeEvery(getConfirmedOrdersRequest.type, getConfirmedOrdersWorker);
	yield takeEvery(getConfirmedOrdersForFilterIdRequest.type, getConfirmedOrdersForFilterIdWorker);
	yield takeEvery(getReturnedOrdersRequest.type, getReturnedOrdersRequestWorker);
	yield takeEvery(getOrderDiscountsRequest.type, getOrderDiscountsRequestWorker);
	yield takeEvery(getOrderDetailsRequest.type, getOrderDetailsRequestWorker);
	yield takeEvery(getOrderDetailsCombinedRequest.type, getOrderDetailsCombinedRequestWorker);
	yield takeEvery(getOrderReturnBreakdownRequest.type, getOrderReturnBreakdownRequestWorker);
	yield takeEvery(getOrderDiscountBreakdownRequest.type, getOrderDiscountBreakdownRequestWorker);
	yield takeEvery(
		getOrderVatCorrectionsBreakdownRequest.type,
		getOrderVatCorrectionsBreakdownRequestWorker,
	);
	yield takeEvery(getOrderReturnItemsRequest.type, getOrderReturnItemsRequestWorker);
	yield takeEvery(createOrderReturnRequest.type, createOrderReturnRequestWorker);
	yield takeEvery(getOrderDiscountItemsRequest.type, getOrderDiscountItemsRequestWorker);
	yield takeEvery(createOrderDiscountRequest.type, createOrderDiscountRequestWorker);
	yield takeEvery(getVatAndEASFeeRequest.type, getVatAndEASFeeRequestWorker);
}
